<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { type AlertVariants, alertVariants } from '.'
import { cn } from '@/lib/utils'

const props = defineProps<{
  class?: HTMLAttributes['class']
  variant?: AlertVariants['variant']
  title?: string
  description?: string
  inlineActions?: boolean
  dismissible?: boolean
  dismissKey?: string
}>()

const isDismissed = useLocalStorage(`alert-dismissde-${props.dismissKey}`, 'false')

function dismiss() {
  isDismissed.value = 'true'
}
</script>

<template>
  <div
    v-if="isDismissed === 'false'"
    :class="cn(alertVariants({ variant, inlineActions }), props.class)"
    role="alert"
  >
    <div class="flex items-start justify-between w-full">
      <div class="flex-1">
        <slot>
          <div class="flex flex-col gap-1">
            <UiAlertTitle v-if="title">
              {{ title }}
            </UiAlertTitle>
            <slot name="description">
              <UiAlertDescription v-if="description">
                {{ description }}
              </UiAlertDescription>
            </slot>
          </div>
        </slot>
        <div
          v-if="$slots.action"
          :class="{ 'mt-1': !inlineActions }"
          class="flex flex-row gap-2"
        >
          <slot name="action" />
        </div>
      </div>
      <UiButton
        v-if="dismissible && dismissKey"
        variant="ghost"
        size="icon"
        class="ml-2 -mt-1 -mr-1"
        @click="dismiss"
      >
        <Icon
          name="heroicons:x-mark"
          class="w-4 h-4"
        />
      </UiButton>
    </div>
  </div>
</template>
